const event = {
  state: {
    selectedEvents: [],
    urgencyData: [],
    impactData: [],
    /* 장애 스마트 분석 팝업 */
    showFaultAnalysisPopup: false,
    faultAnalysisSeqNumber: null,
  },
  mutations: {
    setSelectedEvents: (state, selectedEvents) => {
      state.selectedEvents = selectedEvents;
    },
    setUrgencyData: (state, urgencyData) => {
      state.urgencyData = urgencyData;
    },
    setImpactData: (state, impactData) => {
      state.impactData = impactData;
    },
    setFaultAnalysisSeqNumber: (state, seqNumber) => {
      state.faultAnalysisSeqNumber = seqNumber;
    },
    setShowFaultAnalysisPopup: (state, visible) => {
      state.showFaultAnalysisPopup = visible;
    },
  },
  actions: {
    setSelectedEvents({ commit }, selectedEvents) {
      commit('setSelectedEvents', selectedEvents);
    },
    setUrgencyData({ commit }, urgencyData) {
      commit('setUrgencyData', urgencyData);
    },
    setImpactData({ commit }, impactData) {
      commit('setImpactData', impactData);
    },
    /**
     * 장애 분석 팝업을 연다.
     * @author Ju
     * @param  {[type]}  commit    [description]
     * @param  {Number}  seqNumber 이벤트 이력 seqNumber
     * @return {Boolean}           [description]
     */
    openFaultAnalysisPopup({ commit }, seqNumber) {
      commit('setFaultAnalysisSeqNumber', seqNumber);
      commit('setShowFaultAnalysisPopup', true);
    },
    /**
     * 장애 분석 팝업을 닫는다.
     * @author Ju
     * @param  {[type]}  commit [description]
     * @return {Boolean}        [description]
     */
    closeFaultAnalysisPopup({ commit }) {
      commit('setFaultAnalysisSeqNumber', null);
      commit('setShowFaultAnalysisPopup', false);
    },
  },
};

export default event;



// WEBPACK FOOTER //
// ./src/store/modules/event.js